import { useEffect, useRef, useState } from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '../../firebase'
import { products as fallbackParts } from '../../pages/admin/lib/common'

export const ANIMAL_TYPES = ['エゾシカ', 'ヒグマ'] as const
export type AnimalType = typeof ANIMAL_TYPES[number]

export const useParts = (type?: string): string[] => {
  const [parts, setParts] = useState<string[]>(fallbackParts)
  const allPartsRef = useRef<Record<string, string[]>>({})

  useEffect(() => {
    if (type) {
      return onSnapshot(doc(db, 'partsSettings', type), (snap) => {
        const data = snap.data()
        const list = snap.exists() && Array.isArray(data?.parts) ? data.parts as string[] : []
        setParts(list.length > 0 ? list : fallbackParts)
      })
    }

    // 全獣種の和集合（PartPrices 等で使用）
    allPartsRef.current = {}
    const unsubscribes = ANIMAL_TYPES.map(t =>
      onSnapshot(doc(db, 'partsSettings', t), (snap) => {
        const data = snap.data()
        allPartsRef.current[t] = snap.exists() && Array.isArray(data?.parts) ? data.parts as string[] : []
        const union = [...new Set(Object.values(allPartsRef.current).flat())]
        setParts(union.length > 0 ? union : fallbackParts)
      })
    )
    return () => unsubscribes.forEach(u => u())
  }, [type])

  return parts
}
